import React, { useEffect, useState } from "react";
import CompletedCourses from "../../components/dashboard/CompletedCourses";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/studentAuthContext";


import {
  FaPlus,
  FaCalendarAlt,
  FaComments,
  FaVideo,
} from "react-icons/fa";

export default function Classes() {
  const { student } = useAuth();
  const [isActive, setIsActive] = useState("current");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchCurrentCourses = async () => {
      if (!student?.id) return;

      setLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/api/students/current-courses/${student.id}`);
        setCourses(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch current classes:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentCourses();
  }, [student?.id, BASE_URL]);

  return (
    <div className="bg-gray-50 min-h-screen pb-10 mt-32">
      <div className="max-w-6xl mx-auto px-6 pt-10">

        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="font-bold text-2xl text-gray-800">My Classes</h1>

         <Link to="/enroll">
          <button className="bg-[#1976D2] flex items-center gap-2 px-5 py-2.5 text-white text-sm font-semibold rounded hover:bg-blue-700 transition">
            <FaPlus size={12} />
            ENROLL IN COURSE
          </button>
          </Link>
        </div>

        {/* Tabs */}
        <div className="flex justify-center gap-20 mb-8 border-gray-200">
          <button
            onClick={() => setIsActive("current")}
            className={`pb-4 px-4 text-sm font-bold transition ${
              isActive === "current"
                ? "text-[#1976D2] border-b-2 border-[#1976D2]"
                : "text-gray-500"
            }`}
          >
            CURRENT COURSES
          </button>

          <button
            onClick={() => setIsActive("completed")}
            className={`pb-4 px-4 text-sm font-bold transition ${
              isActive === "completed"
                ? "text-[#1976D2] border-b-2 border-[#1976D2]"
                : "text-gray-500"
            }`}
          >
            COMPLETED COURSES
          </button>
        </div>

        {/* CURRENT COURSES */}
        {isActive === "current" && (
          <div className="space-y-6">
            {loading && (
              <div className="bg-white rounded-lg shadow-sm p-6 text-sm text-gray-500">
                Loading active classes...
              </div>
            )}

            {!loading && courses.length === 0 && (
              <div className="bg-white rounded-lg shadow-sm p-6 text-sm text-gray-500">
                No active classes yet. Enroll in a course to get started.
              </div>
            )}

            {courses.map((course) => (
              <div key={course.id} className="bg-white rounded-lg shadow-sm p-6">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h2 className="font-bold text-lg text-gray-800">
                      {course.title}
                    </h2>
                    <p className="text-gray-400 text-sm">
                      Instructor: {course.tutorName}
                    </p>
                  </div>

                  <span className="bg-[#1976D2] text-white text-xs px-6 py-2 rounded-full font-medium">
                    {course.progress}% Complete
                  </span>
                </div>

                <div className="bg-gray-50 rounded-md p-4 mb-4">
                  <div className="flex items-center gap-2 text-gray-400 text-xs mb-3">
                    <FaVideo /> Learning mode: {course.mode || "online"}
                  </div>

                  <div className="w-full bg-gray-200 h-1.5 rounded-full">
                    <div
                      className="bg-black h-full rounded-full"
                      style={{ width: `${course.progress}%` }}
                    />
                  </div>
                </div>

                <div className="bg-blue-50 border-blue-100 rounded p-3 flex items-center gap-3 mb-4">
                  <FaCalendarAlt className="text-blue-500" />
                  <div>
                    <p className="text-xs font-bold text-gray-700">
                      Next Session
                    </p>
                    <p className="text-[10px] text-gray-500">
                      Check your Schedule page for upcoming sessions.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 text-xs text-gray-600">
                  <Link
                    to="/schedule"
                    className="hover:text-blue-600 flex items-center gap-1"
                  >
                    <FaCalendarAlt /> Schedule
                  </Link>

                  <Link
                    to={
                      student?.id && course.tutorId
                        ? `/messages/${student.id}/${course.tutorId}`
                        : "/messages"
                    }
                    state={{
                      tutorId: course.tutorId,
                      tutorName: course.tutorName,
                    }}
                    className="hover:text-blue-600 flex items-center gap-1"
                  >
                    <FaComments /> Message Tutor
                  </Link>

                  {/* <button className="hover:text-blue-600 flex items-center gap-1">
                    <FaVideo /> Join Class
                  </button> */}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* COMPLETED COURSES */}
        {isActive === "completed" && <CompletedCourses />}
      </div>
    </div>
  );
}